import React, { useState } from "react";
import { FaMicrophone, FaRobot, FaVolumeUp } from "react-icons/fa";
import { testTTS } from "../../services/coreModelService"; // Import the new service function
import CustomAudioPlayer from "../common/CustomAudioPlayer";
import { coreModelIcon, renderCardIcon } from "../common/IconLibrary";
import { useToast } from "../common/ToastContext";
import CoreModelTestTTSModal from "./CoreModelTestTTSModal";

const CoreModelCard = ({ item }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [audioSrc, setAudioSrc] = useState(null);
  const { showToast } = useToast();

  const getIcon = (type) => {
    switch (type) {
      case "stt":
        return <FaMicrophone className="w-6 h-6 text-gray-200" />;
      case "generative":
        return <FaRobot className="w-6 h-6 text-gray-200" />;
      case "tts":
        return <FaVolumeUp className="w-6 h-6 text-gray-200" />;
      default:
        return null;
    }
  };

  const handleClick = () => {
    if (item.type === "tts") {
      setIsModalOpen(true);
    }
  };

  const handleTestTTS = async (text, languageCode = "en-US") => {
    try {
      const audioUrl = await testTTS(item.id, text, languageCode);
      setAudioSrc(audioUrl);
      showToast("TTS audio is ready to play", "success");
    } catch (error) {
      console.error("Error testing TTS:", error);
      showToast("Failed to test TTS", "error");
    }
  };

  return (
    <>
      <div className="card-glass cursor-pointer" onClick={handleClick}>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <span className="text-gray-300 mr-2">
              {renderCardIcon(coreModelIcon, 24)}
            </span>
            <h3 className="text-xl font-semibold text-gray-100">{item.name}</h3>
          </div>
          {getIcon(item.type)}
        </div>
        <div className="text-gray-300 mb-4">
          <p>{item.provider}</p>
          <p>{item.type}</p>
        </div>
        {Object.entries(item.labels).length > 0 && (
          <div className="flex flex-wrap mb-0">
            {Object.entries(item.labels).map(([key, value]) => (
              <span
                key={key}
                className="bg-blue-500 text-white text-xs px-2 py-1 rounded-full mr-2 mb-2"
              >
                {`${key}: ${value}`}
              </span>
            ))}
          </div>
        )}
      </div>
      {item.type === "tts" && (
        <CoreModelTestTTSModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          modelName={item.name}
          labels={item.labels}
          onTestTTS={handleTestTTS}
        >
          {audioSrc && <CustomAudioPlayer src={audioSrc} />}
        </CoreModelTestTTSModal>
      )}
    </>
  );
};

export default CoreModelCard;
